import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useClinicFrame } from './clinic-frame-context';

/**
 * Wraps a tab that only a clinic has: EMR instances, IDIS2GO links, status.
 * The platform has none of these, so its url for one goes back to Overview.
 */
export function ClinicOnly({ children }: { children: ReactNode }): ReactNode {
  const { tenantId, isPlatform } = useClinicFrame();
  if (isPlatform) {
    return <Navigate to={`/clinics/${tenantId}`} replace />;
  }
  return <>{children}</>;
}

export default ClinicOnly;
